import React from 'react';
import { useStore } from '@nanostores/react';
import { hotEditStore } from '../../stores/hotEdit';

/** One line above the preview, only while nothing is selected: the toolbar says the rest. */
export function EditModeHint(): React.ReactElement | null {
  const selection = useStore(hotEditStore.selection);
  if (selection) return null;
  return (
    <div className="shrink-0 border-b border-border/50 bg-muted/40 px-3 py-1.5 text-[11px] text-muted-foreground">
      Click anything in the preview to edit it.
    </div>
  );
}
